// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
class RefinePaneController {
   $scope: any
   appState: any
   citationTrail: any
   facetsService: any
   feed: any
   i18nService: any
   menuManager: any
   quickFiltersScope: any
   quickFiltersService: any
   searchTabs: any
   constructor($scope: any, dataService: any, facetsService: FacetsService, quickFiltersService: QuickFiltersService, appState: AppStateService, l10nService: LocalizationService, i18nService: TranslationService, feed: ResultsFeedService, menuManager: MenuManagerService, citationTrail: CitationTrailService, searchTabs: any, configService: ConfigService ) {
    
      this.displayRefinePane = this.displayRefinePane.bind(this)
      this.independentFacetsScrollingEnabled = this.independentFacetsScrollingEnabled.bind(this)
      this.facetsDisabled = this.facetsDisabled.bind(this)
      this.getActiveFilters = this.getActiveFilters.bind(this)
      this.deactivateFilter = this.deactivateFilter.bind(this)
      this.toggleViewMore = this.toggleViewMore.bind(this)
      this.createFilterRemovalButtonLabel = this.createFilterRemovalButtonLabel.bind(this)
      this.isFacetPanelShown = this.isFacetPanelShown.bind(this)
      this.$scope = $scope
      this.facetsService = facetsService
      this.quickFiltersService = quickFiltersService
      this.appState = appState
      this.i18nService = i18nService
      this.feed = feed
      this.menuManager = menuManager
      this.citationTrail = citationTrail
      this.searchTabs = searchTabs
      this.$scope.facetsScope = this.facetsService.scope
      this.quickFiltersScope = this.quickFiltersService.scope
      this.$scope.toggleFacetValue  = this.facetsService.toggle
      this.$scope.displayRefinePane = this.displayRefinePane
      this.$scope.independentFacetsScrollingEnabled = this.independentFacetsScrollingEnabled
      this.$scope.facetsDisabled =  this.facetsDisabled
      this.$scope.deactivateFilter = this.deactivateFilter
      this.$scope.toggleViewMore = this.toggleViewMore
      this.$scope.createFilterRemovalButtonLabel = this.createFilterRemovalButtonLabel
      this.$scope.isFullTextApplied = false
      this.$scope.isFacetPanelShown = this.isFacetPanelShown
      this.$scope.refinePane = {
         visible: false,
         filtersApplied: false,
         isRTL: l10nService.localization.isRTL,
         selectedFacetsViewDisabled: configService.data.refinePane.selectedFacetsViewDisabled,
         independentFacetsScrollingEnabled: configService.data.refinePane.independentFacetsScrollingEnabled,
         initialFiltersShowCount: 6,
      }

      const applyAppState = () => {
         this.$scope.refinePane.filtersApplied = this.appState.filtersApplied()
         this.$scope.refinePane.numberOfFiltersApplied = this.appState.numberOfFiltersApplied()
         this.$scope.refinePane.activeFilters = this.getActiveFilters()
         this.$scope.refinePane.viewAllSelectedBtn = this.$scope.refinePane.numberOfFiltersApplied > this.$scope.refinePane.initialFiltersShowCount
         this.$scope.refinePane.currentFiltersShowLimit = this.$scope.refinePane.viewAllSelectedBtn ? this.$scope.refinePane.initialFiltersShowCount : this.$scope.refinePane.numberOfFiltersApplied
      }

      this.appState.on('apply', applyAppState)

      const newDataService =  () => {
         const docs = !!dataService.data.search.documents.length
         const facets = this.$scope.facetsScope.applied || this.quickFiltersScope.applied
         this.$scope.refinePane.visible = docs || facets
         this.$scope.refinePane.activeFilters = this.getActiveFilters()
         if (this.$scope.refinePane.visible) {
            const refinePaneElement = document.getElementsByClassName('refinePane')[0]
            if (refinePaneElement) {
               refinePaneElement.scrollTop = 0
            }
         }
      }      

      dataService.on('new', newDataService)

      this.$scope.$on('$destroy', () => {
         this.appState.off('apply', applyAppState)
         return dataService.off('new', newDataService)
      })
   }

   displayRefinePane() {
      return this.$scope.refinePane.visible && (!this.feed.scope.hiddenItems || this.menuManager.menu.facets.open)
   }

   independentFacetsScrollingEnabled() {
      return this.$scope.refinePane.independentFacetsScrollingEnabled || false
   }

   facetsDisabled() {
      return (this.citationTrail.scope.type && (this.$scope.selectedTab === this.searchTabs.citationTrail))
   }

   getActiveFilters() {
      return this.quickFiltersScope.activeFilters.concat(this.$scope.facetsScope.activeFilters)
   }

   deactivateFilter(filter: any) {
      if (filter.facetGroup) {
         return this.facetsService.removeFilterByFacetName(filter.facetGroup, filter.value)
      } else {
         return this.quickFiltersService.toggle(filter)
      }
   }

   createFilterRemovalButtonLabel(filter: any) {
      if (filter.negated) {
         return this.i18nService.translate(this.i18nService.translations.REMOVE_EXCLUSION_FILTER, {filter: filter.label || filter.translation})
      } else {
         return this.i18nService.translate(this.i18nService.translations.REMOVE_FILTER, {filter: filter.label || filter.translation})
      }
   }

   toggleViewMore() {
      this.$scope.refinePane.currentFiltersShowLimit = this.$scope.refinePane.viewAllSelectedBtn ? this.$scope.refinePane.numberOfFiltersApplied : this.$scope.refinePane.initialFiltersShowCount
      this.$scope.refinePane.viewAllSelectedBtn = !this.$scope.refinePane.viewAllSelectedBtn
   }

   isFacetPanelShown() {
      return this.$scope.refinePane?.visible && this.menuManager?.menu?.facets?.open;
   }
}
    
RefinePaneController.$inject = ['$scope', 'dataService', 'facetsService', 'quickFiltersService', 'appStateService', 'localizationService', 'translationService', 'resultsFeedService', 'menuManagerService', 'citationTrailService', '$searchTabs', 'configService']

angular.module('summonApp.controllers').
   controller('RefinePaneCtrl', RefinePaneController)
